import { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as actionTypes from "../actions/actionTypes";

type Link = { text: string; url: string };
type Message = string;
export type Level = "info" | "error";

export type ArgTypes = { message: Message; level?: Level; link?: Link };

export function showNotification({ message, level = "info", link }: ArgTypes) {
  return {
    type: actionTypes.NOTIFICATION_SHOW,
    message: message,
    level: level,
    link: link,
  };
}

export function hideNotification(id) {
  return {
    type: actionTypes.NOTIFICATION_HIDE,
    id: id,
  };
}

export default () => {
  const dispatch = useDispatch(),
    showNotification = useCallback(
      ({ message, level = "info", link }: ArgTypes) => {
        dispatch({
          type: actionTypes.NOTIFICATION_SHOW,
          message: message,
          level: level,
          link: link,
        });
      },
      [dispatch]
    ),
    dismissNotification = useCallback(
      id => {
        dispatch({
          type: actionTypes.NOTIFICATION_HIDE,
          id,
        });
      },
      [dispatch]
    );

  return { showNotification, dismissNotification };
};
